import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import { useGeneral } from "../../components/contexts/GeneralContext";
import ChangeEmail from "../../components/dashboard/profilePartials/ChangeEmail";

const ChangeEmailPage = () => {
 const { discountCoupons } = useGeneral();
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true} component={<ChangeEmail />}  />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ChangeEmailPage;
